export const API = process.env.REACT_APP_BACKEND_URL;

export const fmt = (n) =>
  new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR" }).format(n || 0);

export const track = (name, props = {}) => {
  if (window.posthog) window.posthog.capture(name, props);
};

export async function apiGet(path) {
  const res = await fetch(`${API}${path}`, { credentials: "include" });
  if (!res.ok) {
    const err = new Error("Request failed");
    err.status = res.status;
    err.data = await res.json().catch(() => ({}));
    throw err;
  }
  return res.json();
}

export async function apiSend(path, body, method = "POST", asForm = false) {
  const res = await fetch(`${API}${path}`, {
    method,
    credentials: "include",
    headers: asForm ? undefined : { "Content-Type": "application/json" },
    body: asForm ? body : JSON.stringify(body),
  });
  if (!res.ok) {
    const err = new Error("Request failed");
    err.status = res.status;
    err.data = await res.json().catch(() => ({}));
    throw err;
  }
  return res.json();
}

export async function adminFetch(path, opts = {}, retry = true) {
  const res = await fetch(`${API}${path}`, { credentials: "include", ...opts });
  if (res.status === 401 && retry) {
    const r = await fetch(`${API}/auth/refresh`, {
      method: "POST",
      credentials: "include",
    });
    if (r.ok) return adminFetch(path, opts, false);
  }
  return res;
}

export const productPath = (p) => {
  if (p.product_type === "archive") return `/shop/archive/${p.slug}`;
  if (p.product_type === "edition") return `/shop/editions/${p.slug}`;
  return `/shop/selected-tackle${p.brand_slug ? `/${p.brand_slug}` : ""}/${p.slug}`;
};
